var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHuaweiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8033 31.2332H9.5168C3.25799 31.2332 0.96875 28.951 0.96875 22.7112V9.46511C0.96875 3.22556 3.25799 0.943359 9.5168 0.943359H22.7991C29.0579 0.943359 31.3513 3.22556 31.3513 9.46511V22.7112C31.3513 28.951 29.0621 31.2332 22.8033 31.2332",
    fill: "#C91C2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5255 14.3332C11.5255 14.9771 11.2047 15.3211 10.6223 15.3211C10.0368 15.3211 9.71438 14.9673 9.71438 14.3058V12.0688H8.90844V14.3332C8.90844 15.4472 9.5292 16.0859 10.6115 16.0859C11.7043 16.0859 12.3311 15.435 12.3311 14.3004V12.0664H11.5255V14.3332ZM19.938 12.0664L20.8399 14.7896L21.7193 12.0683H22.555L21.1741 16.0264H20.5008L19.598 13.4265L18.6948 16.0264H18.0277L16.6432 12.0683H17.501L18.3785 14.7896L19.2804 12.0664H19.938ZM13.9238 15.2L13.5624 16.0245H12.7395L14.4896 12.0665H15.2005L16.9435 16.0245H16.0986L15.7416 15.2H13.9238ZM14.2238 14.4857H15.4423L14.8311 13.0688L14.2238 14.4857ZM27.9606 16.0218H27.1652V12.0665H27.9606V16.0218ZM24 14.3222H25.4657V13.6015H24V12.7907H26.1277V12.069H23.2049V16.0241H26.2045V15.3028H24V14.3222ZM7.791 12.0665H6.98539V13.6641H5.1653V12.0665H4.35938V16.0266H5.1653V14.4185H6.98539V16.0266H7.791V12.0665Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.16 21.127C13.3716 21.127 11.1028 23.3888 11.1028 26.1688H11.8172C11.8172 23.7815 13.7653 21.8392 16.16 21.8392C18.5548 21.8392 20.5028 23.7815 20.5028 26.1688H21.2173C21.2173 23.3888 18.9485 21.127 16.16 21.127",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuaweiLogo);
export default __webpack_public_path__ + "static/media/HuaweiLogo.ba7c894e82dddb85e13b4f75efd8f323.svg";
export { ForwardRef as ReactComponent };